import React, { PureComponent } from 'react'
import { Col, FormControl, FormGroup, ControlLabel } from 'react-bootstrap'

class InputNatural extends PureComponent {
  constructor (props) {
    super()
    this.state = {
      realValue: ('' + props.input.value).trim(),
      hasFocus: false
    }
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (prevProps.input.value !== this.props.input.value) {
      const realValue = ('' + this.props.input.value).trim()
      this.setState({
        realValue: realValue
      })
    }
    return null
  }

  componentDidUpdate () {
    // getSnapshotBeforeUpdate() should be used with componentDidUpdate()
  }

  isValid (value) {
    return /^[\d]+$/.test(value)
  }

  handleChange (event) {
    if (this.isValid(event.target.value) && this.validateNumber(event.target.value)) {
      this.props.input.onChange(event)
      if (this.props.onInputChange) {
        this.props.onInputChange(event)
      }
    } else {
      this.props.input.onChange(null)
    }
  }

  validateNumber (value) {
    let result = true
    if (this.props.max !== undefined && this.props.max !== null) {
      if (parseInt(value) > this.props.max) {
        result = false
      }
    }

    if (this.props.min !== undefined && this.props.min !== null) {
      if (parseInt(value) < this.props.min) {
        result = false
      }
    }
    return result
  }

  handleFocus (event) {
    const currentTarget = event.currentTarget
    this.setState({
      hasFocus: true
    }, () => {
      // Timeout requerido en los navegadores Explorer y Edge.
      window.setTimeout(() => {
        currentTarget.select() // Seleccionar el contenido del input.
      }, 50)
    })
  }

  handleBlur (event) {
    const newState = { hasFocus: false }
    let value
    if (!isNaN(this.state.realValue)) {
      // Eliminar los ceros a la izquierda.
      value = ('' + this.state.realValue).replace(/^(0*)([1-9]\d*|\d)$/, '$2')
      newState.realValue = value
    }
    this.setState(newState)
    if (this.props.onHandleBlur) {
      this.props.onHandleBlur(value)
    }
  }

  render () {
    const {
      id,
      colWidth = '100',
      colSm = 0,
      placeholder = '0',
      meta,
      showError = false,
      rightIcon = '',
      leftIcon = '',
      controlLabel,
      componentClass,
      customClass = '',
      disabled = false,
      textAlign,
      maxLength,
      minLength,
      max,
      min
    } = this.props
    const errorMessage = ((showError || meta.touched) && meta.error && typeof meta.error !== 'boolean')
      ? meta.error
      : null
    return (
      <Col sm={colSm} className={'colWidth-' + colWidth + ' ' + customClass}>
        <FormGroup
          className={rightIcon ? 'input-with-icon' : ''}
          validationState={(showError || meta.touched) && meta.error ? 'error' : null}>
          {controlLabel && <ControlLabel>{controlLabel}</ControlLabel>}
          <FormControl
            style={{ textAlign: textAlign || 'right' }}
            value={this.state.realValue}
            id={id}
            disabled={disabled}
            type="text"
            placeholder={placeholder}
            onChange={this.handleChange.bind(this)}
            componentClass={componentClass}
            onFocus={this.handleFocus.bind(this)}
            onBlur={this.handleBlur.bind(this)}
            maxLength={maxLength}
            minLength={minLength}
            max={max}
            min={min}
          />
          <i className={rightIcon || leftIcon} />
          {errorMessage && <span className='help-block text-center'>{errorMessage}</span>}
        </FormGroup>
      </Col>
    )
  }
}

export default InputNatural
